export default __webpack_public_path__ + "static/media/jai.15dc36b8.jpeg";